import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  roles: string[];
}

@Injectable({
  providedIn: 'root',
})
export class SessionManagerService {
  private userSubject = new BehaviorSubject<User | null>(null);
  user$ = this.userSubject.asObservable();

  constructor() {
    // TODO: Initialize user from localStorage or auth service
    const savedUser = localStorage.getItem('user');

    if (savedUser) {
      this.userSubject.next(JSON.parse(savedUser));
    }
  }

  get user(): User | null {
    return this.userSubject.value;
  }

  isOrdersManager(): boolean {
    return this.user?.roles.includes('ORDERS_MANAGER') ?? false;
  }

  isOrdersAdmin(): boolean {
    return this.user?.roles.includes('ORDERS_ADMIN') ?? false;
  }

  setUser(user: User | null) {
    this.userSubject.next(user);
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }

  logout() {
    this.setUser(null);
  }
}
